var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSlides = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13 1v2h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-9.586l4.293 4.293-1.414 1.414L12 18.414l-4.293 4.293-1.414-1.414L10.586 17H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10V1h2Z",
  clipRule: "evenodd"
})));
export { SvgSlides as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEzIDF2MmgxMGMuNTUyMyAwIDEgLjQ0NzcyIDEgMXYxMmMwIC41NTIzLS40NDc3IDEtMSAxaC05LjU4NThsNC4yOTI5IDQuMjkyOS0xLjQxNDIgMS40MTQyTDEyIDE4LjQxNDJsLTQuMjkyODkgNC4yOTI5LTEuNDE0MjItMS40MTQyTDEwLjU4NTggMTdIMWMtLjU1MjI4IDAtMS0uNDQ3Ny0xLTFWNGMwLS41NTIyOC40NDc3MS0xIDEtMWgxMFYxaDJaIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+";